<template>
  <div>
    <v-row>
      <v-col cols="12" lg="6">
          <v-row>
            <v-list-item>
              <v-btn
                v-if="GETTERS_INPUT_ALL.last_status_id < 8 && editable.buttons.add_to_team && editable.can_edit"
                class="my-2"
                x-small
                :color="$mainColor"
                style="color: white; margin-right: 15px;"
                @click="add_to_team_dialog = true;">Добавить участника
              </v-btn>
            </v-list-item>

            <v-dialog v-model="add_to_team_dialog" max-width="40%">
              <user-search
                :attached_list="GETTERS_INPUT_ALL.all_teams"
                :full_view="true"
                @addUser="add_user_to_team($event)"
              />
            </v-dialog>
          </v-row>

          <v-row v-if="GETTERS_INPUT_ALL.all_teams && GETTERS_INPUT_ALL.all_teams.length > 0">
            <v-row>
              <v-col style="margin: auto;" class="pa-0 ml-6 d-flex flex-nowrap ">
                <v-checkbox
                  v-if="GETTERS_INPUT_ALL.last_status_id == 7"
                  v-model="selected_teams"
                  :value="GETTERS_INPUT_ALL.applicant.id"
                ></v-checkbox>
                <p class="pt-1">
                  <v-icon v-if="GETTERS_INPUT_ALL.last_status_id != 7">mdi-arrow-right-bold-circle-outline</v-icon>
                  {{GETTERS_INPUT_ALL.applicant.individual.last_name}} {{GETTERS_INPUT_ALL.applicant.individual.first_name}} {{GETTERS_INPUT_ALL.applicant.individual.middle_name}}
                </p>
              </v-col>
            </v-row>
            <v-row v-for="(item, i) in GETTERS_INPUT_ALL.all_teams" v-if="item.is_active == true" :key="i">
              <v-col style="margin: auto;" class="pa-0 ml-6 d-flex flex-nowrap ">
                <v-checkbox
                  v-if="GETTERS_INPUT_ALL.last_status_id == 7"
                  v-model="selected_teams"
                  :value="item.team_profile.id"
                ></v-checkbox>
                <p class="pt-1">
                  <v-icon v-if="GETTERS_INPUT_ALL.last_status_id != 7">mdi-arrow-right-bold-circle-outline</v-icon>
                  {{item.team_profile.individual.last_name}} {{item.team_profile.individual.first_name}} {{item.team_profile.individual.middle_name}}
                </p>
                <v-tooltip right v-if="(item.creator == GETTERS_CURRENT_USER.id) && GETTERS_INPUT_ALL.last_status_id < 8 && editable.buttons.add_to_team && editable.can_edit">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      color="red lighten-1"
                      @click="delete_from_team(item)"
                      style="margin-top: -16px !important; margin-left: 8px !important;">
                      mdi-delete
                      </v-icon>
                  </template>
                <span>удалить</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-row>
          <v-row v-else>
            {{ $t('ModalCard.command_not_specified') }}
          </v-row>
        <div v-if="GETTERS_INPUT_ALL.last_status_id > 6 && GETTERS_INPUT_ALL.last_status_id < 11 && !from_pass_card">
          <v-row>
            <b>Пропуска :</b>
          </v-row>
          <v-row>
            <div>
              <v-list-item>
                <v-btn
                  v-if="editable.buttons.request_pass && editable.can_edit"
                  class="my-2"
                  x-small
                  :color="$mainColor"
                  :disabled="!selected_teams || selected_teams.length==0"
                  style="color: white; margin-right: 15px;"
                  @click="request_pass()">запросить пропуск
                </v-btn>
              </v-list-item>
            </div>

            <v-dialog v-model="pass_card_dialog" max-width="75%">
              <pass-modal-card
                :is_new="false"
                :current_pass="current_pass"
                :from_proposal="true"
                @updateParent="update_parent_pass($event)"
              />
            </v-dialog>


          </v-row>
          <v-row>
            <div  class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;" v-for="(item, i) in listPasses" :key="i">
              <v-list-item>
                <template>
                  <v-tooltip left v-if="item.creator_id == GETTERS_CURRENT_USER.id && item.status == 0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="red lighten-1"
                        @click="delete_pass_draft(item)"
                        style="margin-top: -16px !important; margin-left: 8px !important;">
                        mdi-delete
                        </v-icon>
                    </template>
                  <span>удалить</span>
                  </v-tooltip>

                  <p
                    class="subtitle-2 text-left"
                    @click="show_pass_card(item)"
                  >
                    <v-badge :color="status_descr(item.status, 'color')" :content="item.guests ? item.guests : ' - '" x-small overlap>
                      <v-chip :color="status_descr(item.status, 'color')" text-color="white">
                        <v-avatar left>
                          <v-icon color="white">mdi-card-account-details</v-icon>
                        </v-avatar>
                            <b style="color:white;">{{format_dateinterval(item)}}</b>
                      </v-chip>
                    </v-badge>
                  </p>


                </template>
              </v-list-item>
            </div>
          </v-row>
        </div>
      </v-col>

      <v-col cols="12" lg="6" class="pt-0">
        <div>
          <div class="subtitle-2" style="align-items: flex-start;" v-if="GETTERS_INPUT_ALL.last_status_id > 3">
            <b>Запланирован эксперимент :</b>
            <div  class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;" v-for="(item, i) in proposal_calendar" :key="i">
              <v-list-item>
                <template>
                  <p>
                    {{formate_datetimeinterval(item)}}
                    <v-icon
                      v-if="editable.buttons.delete_date_interval"
                      @click="delete_item_id = item.id, dialogDeleteDateInterval = true"
                      small
                      style="margin-left:5px;
                      cursor:pointer;"
                      left
                      :disabled="delete_loaded"
                    >
                      mdi-close-circle-outline
                    </v-icon>
                  </p>
                </template>
              </v-list-item>
              <!-- <div v-for="(jtem, i) in GETTERS_INPUT_ALL.passes" :key="jtem.id"  class="d-flex flex-column align-start" style="margin-right: 30px;">
                <v-list-item style="width: 100%; text-align: right;">
                  <template>
                    <p v-if="jtem.calendar_id == item.id">
                      {{ jtem.visit_purpose }}
                    </p>
                  </template>
                </v-list-item>
              </div> -->
            </div>
          </div>
          <template v-if="editable.buttons.can_add_interval && availiable_limit > 0">
            <v-spacer style="height:10px;"></v-spacer>
            <v-list-item>
              <template>
                <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                  <v-btn
                    v-if="!add_additional_interval"
                    @click="add_additional_interval = true"
                    class="my-2"
                    x-small
                    :color="$mainColor"
                    style="color: white; margin-right: 15px;"
                  >{{"Добавить интервал"}}</v-btn>
                  <v-btn
                    v-else
                    @click="add_additional_interval = false"
                    class="my-2"
                    x-small
                    :color="$mainColor"
                    style="color: red; margin-right: 15px;"
                  >{{"отмена"}}</v-btn>
                </div>
              </template>
            </v-list-item>
          </template>

          <div class="bs-actions">
            <div v-if="editable.buttons.can_add_interval && add_additional_interval" class="bs-actions__date">
              <h4 class="ma-0">Добавьте один или НЕСКОЛЬКО интервалов дат</h4>
              <p>Будьте внимательны, заявитель НЕ получает уведомлений о изменениях назначенного времени</p>
              <div>
                <set-date-intervals
                  @updateParent="update_parent($event)"
                  :proposal_id="idProposal"
                  :station_id="GETTERS_INPUT_ALL.stations[0].id"
                  :can_edit="true"
                  :input_dates ="null"
                  :interval_multiple="false"
                  :availiable_limit="availiable_limit"
                  :calendar_id="0"
                  :add_new="true"
                  :small_view="true"
                  :calendar_type="editable.buttons.can_add_interval && GETTERS_INPUT_ALL.last_status_id == 4 ? 5 : 2"
                  :calendar_start="editable.session.date_start ? editable.session.date_start : undefined"
                  :calendar_end="editable.session.date_end ? editable.session.date_end : undefined"
                />
              </div>
            </div>

            <v-dialog v-model="dialogDeleteDateInterval" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">Подтверждение</v-card-title>
                    <v-card-text>Вы уверены, что хотите удалить запланированный интервал?</v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" outlined :color="$mainColor" @click="dialogDeleteDateInterval = false">{{$t('cancel')}}</v-btn>
                    <v-btn color="green darken-1" outlined :color="$mainColor" @click="dialogDeleteDateInterval = false, deleteDateInterval(delete_item_id)">Да, удалить</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="GETTERS_INPUT_ALL.last_status_id > 6 && GETTERS_INPUT_ALL.last_status_id < 11 && !from_pass_card">
      <v-card-text>
        <v-list class="d-flex align-center justify-start">
          <v-list-item>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="background-color: #E57373  !important;"
              @click=""
              v-bind="attrs"
              v-on="on"
              x-small>
                Отменен
            </v-btn>
          </template>
            <span>Пропуск не оформлен! Смотрите комментарий в карточке пропуска.</span>
            </v-tooltip>
          </v-list-item>
          <v-list-item>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  style="background-color: #a9a9a9 !important;"
                  @click=""
                  v-bind="attrs"
                  v-on="on"
                  x-small
                >
                  Новый запрос
                </v-btn>
              </template>
              <span>Скоро вашим запросом займутся, ожидайте уведомления</span>
            </v-tooltip>
          </v-list-item>

          <v-list-item>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="background-color: #ada509 !important;"
              @click=""
              v-bind="attrs"
              v-on="on"
              x-small>
                Оформляется
            </v-btn>
          </template>
            <span>Пропуск в процессе оформления, ожидайте уведомления</span>
            </v-tooltip>
          </v-list-item>
          <v-list-item>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="background-color: #1b8e30 !important;"
              @click=""
              v-bind="attrs"
              v-on="on"
              x-small>
                Готов
            </v-btn>
          </template>
            <span>Пропуск оформлен</span>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-row>

    <v-dialog v-model="dialogRequestPass" max-width="40%">
      <v-card>
        <v-card-title class="headline"> Запрос пропуска по заявке {{ this.GETTERS_INPUT_ALL.id }}
        </v-card-title>
        <v-list-item>
          <template>
            <p  v-for="(person, i) in selected_fio" :key="i"
              class="subtitle-2 text-left mr-2"
            >
                <v-chip :color="(person.id == current_person_id) ? '#15c013' : '#237622' " text-color="white" @click="change_person(person)">
                  <v-avatar left>
                    <v-icon color="white">mdi-account-tie</v-icon>
                  </v-avatar>
                      <b style="color:white;">{{ person.fio}}</b>
                </v-chip>
            </p>
          </template>
        </v-list-item>


        <v-card-text>
        
          <v-menu
            ref="date_menu"
            v-model="date_menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="datesActionsV"
                label="Дата или интервал"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :error="error_datesActions"
                @input="datesActionsV.length > 0 ? error_datesActions = false : error_datesActions = true"
              ></v-text-field>
            </template>
            <v-date-picker
              :color="$mainColor"
              show-adjacent-months
              type="date"
              v-model="datesActions"
              landscape
              flat
              class='mt-2'
              locale='ru-RU'
              no-title
              show-current="calendar_current"
              first-day-of-week=1
              :min="min"
              :max="max"
              scrollable
              range>

              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="date_menu = false"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>

          <v-radio-group
            v-model="pass_type"
            :inline=true
            :error="error_pass_type"
            @input="pass_type > 0 ? error_pass_type = false : error_pass_type = true"
          >
            <v-radio
              label= "с сопровождением (до 23:00)"
              color="error"
              value="1"
            ></v-radio>
            <v-radio
              label="без сопровождения (до 18:00)"
              color="success"
              value="2"
            ></v-radio>
          </v-radio-group>

          <v-checkbox
            :color="$mainColor"
            v-model="need_applicant_equipment_pass"
            label="требуется мат.пропуск"
          ></v-checkbox>

          <v-textarea
            v-model="pass_justification"
            outlined
            placeholder="Обоснование, доп.информация: укажите договор, соглашение и т.п."
            type="number"
            counter="1000"
            maxLength="1000"
            rows="3"
          ></v-textarea>

          <v-list-item-title class="help-step modal-mul-select">Ответственные : </v-list-item-title>
          <v-select
            v-model="pass_responsibles"
            :items="listResps"
            item-text="name"
            item-value="id"
            outlined
            chips
            multiple
          ></v-select>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialogRequestPass = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="green darken-1" text
            @click="create_pass()">{{"Отправить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import setDateIntervals from "../../Proposals/setDateIntervals.vue"
import userSearch from '../../Common/user-search/userSearch.vue'
import passModalCard from '../../Common/Pass/modalCard.vue'
export default {
  components: {
      setDateIntervals,
      userSearch,
      passModalCard,
  },

  name: 'ScheduleProposalCard',

    props: {
        id: [String, Number],
        status_id: Number,
        editable: [Object, Array],
        idProposal: [String, Number],
        expertise: Boolean,
        from_pass_card: Boolean,
    },
    computed: {
        ...mapGetters([
          'GETTERS_LOGIN',
          'GETTERS_INPUT_ALL',
          'GETTERS_CURRENT_USER',
          'GETTERS_BS_LIST',
        ]),

      datesActionsV() {
        this.max = this.editable.session.date_end ? this.editable.session.date_end : undefined
        this.min = this.editable.session.date_start ? this.editable.session.date_start : undefined
        if(this.datesActions.length <= 0)
          return ''

        this.temp_arr = []
        if(this.datesActions.length == 1){
          this.temp_arr[0] = this.datesActions[0]
          this.temp_arr[1] = this.datesActions[0]

          var start_date = new Date(this.temp_arr[0])
          var mm = start_date.getMonth() + 1;
          mm = Number(mm) < 10 ? `0${mm}` : mm
          var dd = start_date.getDate() 
          dd = Number(dd) < 10 ? `0${dd}` : dd
          this.min =  start_date.getFullYear() + '-' + mm + '-' + dd; 

          start_date.setDate(start_date.getDate() + 14)
          mm = start_date.getMonth() + 1;
          mm = Number(mm) < 10 ? `0${mm}` : mm

          dd = start_date.getDate() 
          dd = Number(dd) < 10 ? `0${dd}` : dd
          var new_max =  start_date.getFullYear() + '-' + mm + '-' + dd; 
          if(!this.max || new_max < this.max)
            this.max = new_max
        }
        else if(this.datesActions[0] > this.datesActions[1]){
          this.temp_arr[0] = this.datesActions[1];
          this.temp_arr[1] = this.datesActions[0];
        }
        else{
          this.temp_arr[0] = this.datesActions[0];
          this.temp_arr[1] = this.datesActions[1];
        }

        return this.temp_arr[0].split('-').reverse().join('.') + ' - ' + this.temp_arr[1].split('-').reverse().join('.')
      }
    },


    beforeMount() {
      this.preload();

      var add = false;
      this.listResps = [];
      var all = this.GETTERS_BS_LIST;
      var name = '';

      Object.entries(all).forEach(([key, user]) => {
        add = false;
        user.station_ids.forEach(cur => {
          if(cur == this.GETTERS_INPUT_ALL.stations[0].id)
            add = true;
        });
        if(add){
          name = user.last_name + ' ' + user.first_name[0] + '.'  + user.middle_name[0] + '.'
          this.listResps.push({name: name, id: user.id});
        }
      });


    },

    mounted() {
    },
    
    data() {
        return {
            loaded: false,
            checkComment: false,
            dateIntervalCheck: [],
            addedDateInterval: [],
            end_time: null,
            start_time: null,
            time: null,
            menu_time: false,
            menu_end_time: false,
            proposal_calendar: [],
            availiable_limit: 0,
            delete_loaded: false,

            add_additional_interval: false,
            dialogDeleteDateInterval: false,
            delete_item_id: null,
            add_to_team_dialog: false,

          //PASSES
            listPasses: {},

            pass_card_dialog:false,
            current_pass: {},

            selected_teams: [],
            selected_fio: [],

            dialogRequestPass: false,
            date_menu: false,
            datesActions: [],
            min: null,
            max: null,
            pass_type: 0,
            need_applicant_equipment_pass: false,
            pass_justification: '',
            listResps: [],
            pass_responsibles: [],

            error_pass_type: false,
            error_datesActions: false,

            current_person_id: 0,
          }
    },

    watch:{
      'GETTERS_INPUT_ALL.id'(val){
        this.preload();
      },
    },

    methods: {
      ...mapActions([
        'GET_PROPOSAL_LIST',
        'DELETE_CALENDAR_REC',
        'PROPOSAL_CHANGE_TEAM',
        'GET_LIST_PASSES',
        'NEW_PASS',
        'UPDATE_PASS',
        'GET_PASS_ALL',
      ]),
      ...mapMutations([
        'UPDATE_CURRENT_CALENDAR',
        'UPDATE_OVERLAY',
      ]),

      show_pass_card(pass){
        this.UPDATE_OVERLAY(true)
        // console.log('show_pass_card', pass)
        // this.current_pass = pass
        this.GET_PASS_ALL(pass.id)
          .then(() => {
            this.UPDATE_OVERLAY(false)
            this.pass_card_dialog = true
          })        
      },
        
      preload(){
        this.add_additional_interval = false
        if(this.GETTERS_INPUT_ALL.last_status_id > 3){
          this.load_proposal_calendars()
        }
        
        this.load_passes()
        this.min = this.editable.session.date_start ? this.editable.session.date_start : undefined
        this.max = this.editable.session.date_end ? this.editable.session.date_end : undefined
      },

      load_passes(){
        if(this.GETTERS_INPUT_ALL.last_status_id > 6 && this.GETTERS_INPUT_ALL.last_status_id < 11){
          this.GET_LIST_PASSES({status_id: -1, view_type: 'proposal', proposal_id: this.GETTERS_INPUT_ALL.id})
            .then((res) => {
              this.listPasses = res.data;
            });
        }
      },

      change_person(person){
        this.current_person_id = person.id
        // console.log('change_person', person)
      },

        delete_pass_draft(pass){
          // console.log('delete_pass_draft', pass)

          this.UPDATE_OVERLAY(true)
          var data = {
            pass_id: pass.id,
            action: 'delete',
          }

          try {
              this.UPDATE_PASS(data)
              .then((res) => {
                // console.log('PASS', res)
                this.UPDATE_OVERLAY(false)
                if(res.status){
                  this.$messageHelper(`Пропуск удален`, 'success', 3000)
                  this.preload();
                  this.dialogRequestPass = false
                }
                else{
                  this.$messageHelper(`${this.$t('error_occurred')}`, 'error', 3000)
                }
              })
          } catch (e) {
              this.UPDATE_OVERLAY(false)
              this.$messageHelper(`${this.$t('error_occurred')}: ${e}`, 'error', 3000)
          }

        },


        validate_new_pass() {
          this.error_pass_type = false
          this.error_datesActions = false

          var res = true
          if (this.datesActions.length <= 0){
            this.error_datesActions = true
            res = false
          }

          if(this.pass_type == 0){
            this.error_pass_type = true
            res =false
          }

          return res
        },

        create_pass(){
          this.UPDATE_OVERLAY(true)
          if(!this.validate_new_pass()){
            this.UPDATE_OVERLAY(false)
            return
          }

          var data = {
            proposal_id: this.GETTERS_INPUT_ALL.id,
            start_date: this.datesActions[0].split('.').reverse().join('-'),
            finish_date: this.datesActions[1].split('.').reverse().join('-'),
            guests: this.selected_teams,
            need_applicant_equipment_pass: this.need_applicant_equipment_pass,
            justification: this.pass_justification,
            responsibles: this.pass_responsibles,
            pass_type: this.pass_type,
          }

          try {
              this.NEW_PASS(data)
              .then((res) => {
                // console.log('PASS', res)
                this.UPDATE_OVERLAY(false)
                if(res.status && res.data.id > 0){
                  this.$messageHelper(`Заявка на пропуск подана`, 'success', 3000)
                  this.preload();
                  this.dialogRequestPass = false
                }
                else{
                  this.$messageHelper(`${this.$t('error_occurred')}`, 'error', 3000)
                }
              })
          } catch (e) {
              this.UPDATE_OVERLAY(false)
              this.$messageHelper(`${this.$t('error_occurred')}: ${e}`, 'error', 3000)
          }
        },

        request_pass(){
          this.selected_fio = []
          this.selected_teams.forEach(item => {
            if(item == this.GETTERS_INPUT_ALL.applicant.id){
              this.selected_fio.push({'profile_id': item, 'fio': this.GETTERS_INPUT_ALL.author})
            }
            else{
              this.GETTERS_INPUT_ALL.all_teams.forEach(team => {
                if(item == team.team_profile.id){
                  this.selected_fio.push({'profile_id': team.team_profile.id, 'fio': team.team_profile.individual.last_name + ' ' + team.team_profile.individual.first_name[0] + '.' + team.team_profile.individual.middle_name[0] + '.'})
                }
              });
            }
          })

          this.dialogRequestPass = true
        },

        deleteDateInterval(interval_id) {
          var args = {
            id: interval_id,
            proposal_id: this.idProposal
          }
          this.delete_loaded = true
          this.DELETE_CALENDAR_REC(args)
          .then(res => {
            this.load_proposal_calendars()
            // this.UPDATE_CURRENT_CALENDAR(true)
            this.$emit('loadEditable')
            this.$emit('reloadParent')
            this.$emit('reloadCalendar')
            this.delete_loaded = false
          })
          .catch(() => {
              this.delete_loaded = false
          })
        },

        status_descr(status, type){
          if(type == 'descr'){
            if (status == 4)
              return 'Черновик'
            else if (status == 0)
              return 'Запрошен'
            else if (status == 1)
              return 'Оформляется'
            else if (status == 2)
              return 'Готов'
            else if (status == 3)
              return 'Отменен'
            else
              return 'Не определен'
          }
          else{
            if (status == 0 || status == 4)
              return '#a9a9a9'
            else if (status == 1)
              return '#ada509'
            else if (status == 2)
              return '#1b8e30'
            else if (status == 3)
              return 'red lighten-2'
            else
              return 'red lighten-2'
          }
        },

        formate_datetimeinterval(item){
          var date_obj_1 = new Date(item.start_date)
          var date_obj_2 = new Date(item.finish_date)
          var diff = (date_obj_2 - date_obj_1) / 3600000

          return this.formate_datetime(date_obj_1) + ' : ' + this.formate_datetime(date_obj_2) + ' (' + diff.toFixed(1) + ' ч.)'
        },

        formate_datetime(date_obj){
          var month = date_obj.getMonth() + 1
          var date = date_obj.getDate()
          var m = date_obj.getMinutes()
          var h = date_obj.getHours()
          if (h<10) h = '0'+h
          if (m<10) m = '0'+m
          if (month<10) month = '0' + month
          if (date<10) date = '0' + date

          return date + '.' + month + '.' + date_obj.getFullYear() + ' ' + h + ':' + m
        },

        format_dateinterval(item){
          var date_obj_1 = new Date(item.start_date)
          var date_obj_2 = new Date(item.finish_date)

          return this.formate_date(date_obj_1) + ' : ' + this.formate_date(date_obj_2)
        },

        formate_date(date_obj){
          var month = date_obj.getMonth() + 1
          var date = date_obj.getDate()
          if (month<10) month = '0' + month
          if (date<10) date = '0' + date

          return date + '.' + month + '.' + date_obj.getFullYear()
        },

        update_parent_pass(item) {
          this.load_passes()
        },

        update_parent(item) {
          this.$emit('reloadLists')
            this.$emit('reloadCalendar')
          this.load_proposal_calendars()
          // this.UPDATE_CURRENT_CALENDAR(true)
        },

        load_proposal_calendars(){
          this.GET_PROPOSAL_LIST({proposal_id:this.idProposal})
          .then((res) => {
            this.proposal_calendar = res;

            var reserved_time = 0;
            var start_date, end_date, diff;
            this.proposal_calendar.forEach(item => {
              start_date = new Date(item.start_date);
              end_date = new Date(item.finish_date);
              diff = (end_date - start_date)/ 3600000;
              reserved_time += diff;
            });

            var provided_experiment_duration = this.GETTERS_INPUT_ALL.provided_experiment_duration
            if(provided_experiment_duration > 0)
              this.availiable_limit = provided_experiment_duration - reserved_time
            else
              this.availiable_limit = 720 - reserved_time
            if(this.availiable_limit <= 0)
              this.add_additional_interval = false


          })
          .catch((e) => {
            console.log('eee', e);
            this.$messageHelper(e.message, 'error', 4000);
          });
        },

        add_user_to_team(profile_id){
          this.UPDATE_OVERLAY(true)
          this.PROPOSAL_CHANGE_TEAM({
            'type': 'add',
            'proposal_id': this.GETTERS_INPUT_ALL.id,
            'profile_id': profile_id,
          })
          .then((data) => {
            this.UPDATE_OVERLAY(false)
            if(data.error){
              this.$messageHelper(data.error, 'error', 3000);
            }
            else{
              this.add_to_team_dialog = false
            }
          })
        },

        delete_from_team(item){
          this.UPDATE_OVERLAY(true)
          this.PROPOSAL_CHANGE_TEAM({
            'type': 'delete',
            'proposal_id': this.GETTERS_INPUT_ALL.id,
            'users': {proposal_team_id: item.id},
          })
          .then((data) => {
            this.UPDATE_OVERLAY(false)
            if(data.error){
              this.$messageHelper(data.error, 'error', 3000);
            }
          })
        },

    }
}
</script>
<style>
    .bs-actions {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .bs-actions__text,
    .bs-actions__textarea {
        width: 100%;
        margin-left:0px;
        margin-right:15px;
        /* background-color:rgba(229,115,115,0.4); */
    }

    .bs-actions__text {
        padding: 15px 15px 0 15px;
        /* border: 1px solid red; */
        background-color:rgba(255,255,255,0);
        border-radius:8px;
        margin-top:20px;
    }

    .v-input--selection-controls {
        margin-top: 0;
    }
    .bs-actions__save {
        padding-top: 15px;
        padding-bottom: 15px;
    }
    .date-interval .v-input__slot {
        margin-bottom: 0 !important;
    }
    .date-interval .v-messages {
        display: none !important;
    }
    .bs-actions__date{
        margin-left:0px;
        width:100%;
        background-color:rgba(255,255,255,0.9);
        border-radius:8px;
        padding: 0 15px 0 15px;
        margin-right:15px;
        margin-top:20px;
    }
</style>
